import React, { useState } from 'react';
import coinIcon from '@/assets/images/gold-coin.svg';
import { createPortal } from 'react-dom';
import { DMImage } from '../custom-image/custom-image';
import DMDialog from '../dialog';
import { DMLink } from '../link';
import { SkeletonLoader } from '../skeleton-loader';

type CoinAndLevelUpProps = {
  coin: number;
  points: number;
};
function CoinAndLevelUp({ coin, points }: CoinAndLevelUpProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      {open &&
        createPortal(
          <DMDialog
            open={open}
            setOpen={setOpen}
            className='max-w-[800px]'
            content={
              <div className='mb-2 p-8'>
                <h3 className='text-white mt-3'>Welcome to the Rewards Program!</h3>

                <div className='mt-8'>
                  <h4 className='text-brand-primary-text mb-1 flex gap-1 items-center text-lg'>
                    What are Coins?{' '}
                    <DMImage src={coinIcon} alt='coin Icon' width={20} height={20} />
                  </h4>
                  <p>
                    Coins are our currency that you can earn by purchasing courses. They can be used
                    for various rewards, including discounts on future courses,{' '}
                    <DMLink href='/achievements' className='underline'>
                      rewards
                    </DMLink>{' '}
                    redemptions, and special events.
                  </p>
                  <h4 className='mt-6 text-brand-primary-text mb-1 flex gap-1 items-center text-lg'>
                    What are XP?
                    <DMImage
                      src='/images/home/level-up.png'
                      alt='levelup icon'
                      width={30}
                      height={32}
                    />
                  </h4>
                  <p>
                    Gaining XP not only reflects your learning journey but also unlocks levels and
                    achievements that can lead to discount on courses. The more you learn, the more
                    XP you earn!
                  </p>

                  <div className='mt-8 '>
                    <DMLink href='/level-up' className='text-brand-silver underline'>
                      How does it work?
                    </DMLink>
                  </div>
                </div>
              </div>
            }
          />,
          document.body
        )}

      <div
        className='flex items-center gap-2 hover:bg-brand-secondary rounded-md p-2 cursor-pointer'
        onClick={() => setOpen(true)}
      >
        <div className='flex items-center gap-1'>
          <DMImage src={coinIcon} alt='coin Icon' width={16} height={16} />
          <p className='text-xs font-semibold'>
            {coin ?? <SkeletonLoader width={20} height={20} />}
          </p>
        </div>
        <div className='flex items-center gap-2'>
          <DMImage src='/images/home/level-up.png' alt='levelup icon' width={20} height={32} />
          {points ? (
            <p className='text-xs -ml-1 font-semibold'>{points}+</p>
          ) : (
            <SkeletonLoader width={20} height={20} />
          )}
        </div>
      </div>
    </>
  );
}

export default CoinAndLevelUp;
